import React from 'react';

import './index.scss';

interface IAIPageNavigationLoadingProps {
  text?: string;
}

const AIPageNavigationLoading: React.FC<IAIPageNavigationLoadingProps> = (props) => {
  const { text } = props;

  return (
    <div className="dbh-ai-search-loading-wrapper">
      <div className="dbh-ai-search-loading">
        <div className="dbh-ai-search-loading-wrap">
          <i className="dbh-ai-search-loading-outline"></i>
          <i className="dbh-ai-search-loading-wave"></i>
          <i className="dbh-ai-search-loading-circle"></i>
          <i className="dbh-ai-search-loading-star"></i>
        </div>
      </div>
      {text && <div className="dbh-ai-search-loading-text">{text}</div>}
    </div>
  );
};

export default AIPageNavigationLoading;
